import type { LatLng } from '@guildite/domain/location';

// Browser geolocation today; Capacitor's Geolocation plugin can replace this
// in the native apps without screen changes.
export function currentPosition(): Promise<LatLng> {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new Error('This device cannot share its location.'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      position => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }),
      error => reject(new Error(error.code === error.PERMISSION_DENIED
        ? 'Location access is off. Allow it in your browser settings, or tap the map instead.'
        : 'Your location could not be found. Tap the map instead.')),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 60000 },
    );
  });
}

// A rough position for finding the town only ("Use my current location"):
// low accuracy is faster, uses less battery and is all a town needs.
export function roughPosition(): Promise<LatLng> {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new LocationError('unsupported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      position => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }),
      error => reject(new LocationError(error.code === error.PERMISSION_DENIED ? 'denied' : 'failed')),
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 10 * 60 * 1000 },
    );
  });
}

export class LocationError extends Error {
  readonly reason: 'unsupported' | 'denied' | 'failed';
  constructor(reason: 'unsupported' | 'denied' | 'failed') {
    super(reason === 'denied' ? 'Location access is off for Guildite.' : 'Your location could not be found.');
    this.reason = reason;
  }
}
